import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { List, ListParams } from '../types/main';
import { ItemId, Order } from '../types/items';
import { transformList } from './transformer';
import { OrderPayload } from '../store/modules/orders/types';

class OrderService {
  private route = apis.order;

  constructor(private api: ApiService) {}

  list = (params: ListParams) => this.api
    .get<List<Order>>(this.route.list, params)
    .then(transformList);

  get = (id: ItemId) => this.api.get<Order>(`${this.route.list}/${id}`);

  template = () => this.api.get<Order>(`${this.route.list}/new`);

  save = (id: ItemId, payload: OrderPayload) => this.api.put(`${this.route.list}/${id}`, payload);

  create = (payload: OrderPayload) => this.api.post<Order>(this.route.list, payload);

  cancel = (id: ItemId, notes: string) => this.api.post(this.route.cancel(id), { notes });
}

export default new OrderService(apiService);
